import { z } from "zod";
import { timestampSchema } from "./timestamp";
import { payoutPurposeSchema } from "./payout";

export const transactionTypeSchema = z.enum(["earn", "payout", "adjustment"]);
export type TransactionType = z.infer<typeof transactionTypeSchema>;

export const transactionSchema = z.object({
  id: z.string(),
  userId: z.string(),
  // dodatnie = przychód dziecka, ujemne = wypłata/korekta w dół
  amountMinor: z.number().int(),
  type: transactionTypeSchema,
  relatedCompletionId: z.string().optional(),
  relatedPayoutId: z.string().optional(),
  // UID dorosłego, który płaci za tą pozycję earn (z chore.fundedBy).
  // Pozwala potem agregować „Babcia ufundowała X PLN".
  fundedBy: z.string().optional(),
  note: z.string().max(200).optional(),
  // Snapshot przeznaczenia z payout (tylko dla type "payout").
  purpose: payoutPurposeSchema.optional(),
  relatedGoalId: z.string().optional(),
  createdAt: timestampSchema,
  createdBy: z.string(),
});
export type Transaction = z.infer<typeof transactionSchema>;
